// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "container-2eiuC";
var _4 = "header-1JL7I";
var _5 = "icon-3ZsAP";
var _6 = "buttons-vu-Cf";
var _7 = "button-2YKO7";
var _8 = "back-1URHi";
export { _1 as "__esModule", _2 as "tablet", _3 as "container", _4 as "header", _5 as "icon", _6 as "buttons", _7 as "button", _8 as "back" }
export default { "__esModule": _1, "tablet": _2, "container": _3, "header": _4, "icon": _5, "buttons": _6, "button": _7, "back": _8 }
